/**
 * SocialMediaMetricsService
 * Service for social media metrics operations
 * Route: api/socialmedia/metrics
 */
import { BaseService } from '../base/BaseService';
/**
 * SocialMediaMetricsService
 * Handles social media metrics queries
 */
export class SocialMediaMetricsService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? SocialMediaMetricsService.DEFAULT_SERVICE_PATH,
            basePath: SocialMediaMetricsService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET DAILY METRICS ====================
    /**
     * Get daily metrics for an account
     * GET api/socialmedia/metrics/daily?accountId={accountId}&startDate={startDate}&endDate={endDate}
     */
    async getDailyMetrics(accountId, startDate, endDate) {
        const response = await this.getDailyMetricsRaw(accountId, startDate, endDate);
        return response.data ?? [];
    }
    /**
     * Get daily metrics with full response
     */
    getDailyMetricsRaw(accountId, startDate, endDate) {
        const endpoint = this.getEndpoint('daily', 'daily');
        const url = this.buildUrl(endpoint);
        const params = new URLSearchParams({ accountId });
        if (startDate)
            params.append('startDate', startDate);
        if (endDate)
            params.append('endDate', endDate);
        return this.http.get(`${url}?${params.toString()}`);
    }
    // ==================== GET HOURLY METRICS ====================
    /**
     * Get hourly metrics for an account
     * GET api/socialmedia/metrics/hourly?accountId={accountId}&startDate={startDate}&endDate={endDate}
     */
    async getHourlyMetrics(accountId, startDate, endDate) {
        const response = await this.getHourlyMetricsRaw(accountId, startDate, endDate);
        return response.data ?? [];
    }
    /**
     * Get hourly metrics with full response
     */
    getHourlyMetricsRaw(accountId, startDate, endDate) {
        const endpoint = this.getEndpoint('hourly', 'hourly');
        const url = this.buildUrl(endpoint);
        const params = new URLSearchParams({ accountId });
        if (startDate)
            params.append('startDate', startDate);
        if (endDate)
            params.append('endDate', endDate);
        return this.http.get(`${url}?${params.toString()}`);
    }
    // ==================== GET LATEST METRICS ====================
    /**
     * Get latest daily metrics for an account
     * GET api/socialmedia/metrics/latest?accountId={accountId}
     */
    async getLatestMetrics(accountId) {
        const response = await this.getLatestMetricsRaw(accountId);
        return response.data ?? null;
    }
    /**
     * Get latest daily metrics with full response
     */
    getLatestMetricsRaw(accountId) {
        const endpoint = this.getEndpoint('latest', 'latest');
        const url = this.buildUrl(endpoint);
        return this.http.get(`${url}?accountId=${accountId}`);
    }
    // ==================== GET AUDIENCE INSIGHTS ====================
    /**
     * Get audience insights for an account
     * GET api/socialmedia/metrics/audience?accountId={accountId}&startDate={startDate}&endDate={endDate}
     */
    async getAudienceInsights(accountId, startDate, endDate) {
        const response = await this.getAudienceInsightsRaw(accountId, startDate, endDate);
        return response.data ?? [];
    }
    /**
     * Get audience insights with full response
     */
    getAudienceInsightsRaw(accountId, startDate, endDate) {
        const endpoint = this.getEndpoint('audience', 'audience');
        const url = this.buildUrl(endpoint);
        const params = new URLSearchParams({ accountId });
        if (startDate)
            params.append('startDate', startDate);
        if (endDate)
            params.append('endDate', endDate);
        return this.http.get(`${url}?${params.toString()}`);
    }
}
SocialMediaMetricsService.DEFAULT_SERVICE_PATH = 'socialmedia';
SocialMediaMetricsService.BASE_PATH = 'api/socialmedia/metrics';
//# sourceMappingURL=SocialMediaMetricsService.js.map